module.exports = "<div class=\"alert {{ $ctrl.messageService.alerttype }} {{ $ctrl.messageService.class }}\" ng-if=\"$ctrl.messageService.display\">\n    <p ng-bind-html=\"$ctrl.messageService.display\"></p>\n    <a class=\"c-message__link\" ng-if=\"$ctrl.messageService.displaylink\" ui-sref=\"{{$ctrl.messageService.displaylink}}\">\n        {{$ctrl.messageService.displaylinktext}}\n    </a>\n    <button ng-if=\"$ctrl.closable\" type=\"button\" class=\"close\" data-ng-click=\"$ctrl.messageService.clear()\">×</button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/base/views/message.html
// module id = 381
// module chunks = 0